<template>
  <div id="app">
    <SideEffectLoading v-if="appStore.hasSideEffectLoading" />
    <CustomerDialog v-if="modal.customer.visible" />
    <VendorDialog v-if="modal.vendor.visible" />
    <EmployeeDialog v-if="modal.employee.visible" />
    <SmithDialog v-if="modal.smith.visible" />
    <ProductDialog v-if="modal.product.visible" />
    <SkuDialog v-if="modal.sku.visible" />
    <CashTransactionDialog v-if="modal.cashTransaction.visible" />
    <ItemTransactionDialog v-if="modal.itemTransaction.visible" />
    <TrackRecordDialog v-if="modal.trackRecord.visible" />
    <PandyTransferItemDialog v-if="modal.pandyTransferItem.visible" />
    <PandyTransferItemRecRetDialog v-if="modal.pandyTransferItemRecRet.visible" />
    <router-view />
  </div>
</template>

<script setup>
import { useModalStore } from '@/stores/modal'
import { useAppStore } from '@/stores/app'
import SideEffectLoading from './components/SideEffectLoading.vue'
import CustomerDialog from './components/CustomerDialog.vue'
import VendorDialog from './components/VendorDialog.vue'
import EmployeeDialog from './components/EmployeeDialog.vue'
import SmithDialog from './components/SmithDialog.vue'
import ProductDialog from './components/ProductDialog.vue'
import SkuDialog from './components/SkuDialog.vue'
import CashTransactionDialog from './components/CashTransactionDialog.vue'
import ItemTransactionDialog from './components/ItemTransactionDialog.vue'
import TrackRecordDialog from './components/TrackRecordDialog.vue'
import PandyTransferItemDialog from './components/PandyTransferItemDialog.vue'
import PandyTransferItemRecRetDialog from './components/PandyTransferItemRecRetDialog.vue'

const modal = useModalStore()
const appStore = useAppStore()
</script>

<style></style>
